import styled, { css } from 'styled-components';

import IconButtonClose from '~/components/misc/icon-button-close';

export const Header = styled.div<{ disabled?: boolean }>`
	align-items: center;
	display: flex;
	justify-content: space-between;
	margin: 0;
	text-align: left;
	width: 100%;

	${({ disabled }) =>
		disabled &&
		css`
			background-color: inherit;
			color: inherit;
			opacity: 0.7;
		`}
`;

export const CloseButton = styled(IconButtonClose)`
	align-items: center;
	background-color: var(--new-qd--modal-header-close-icon-bg);
	border-radius: 50%;
	display: flex;
	justify-content: center;
	padding: 4px;

	svg {
		fill: var(--new-qd--modal-header-close-icon-color) !important;
		height: 24px;
		width: 24px;
	}
`;
